import { useEffect } from "react"
import { useDispatch } from "react-redux"
import { updateCart } from "../../redux/actions/cart"
import { calculateTotalCart } from "../../lib/helpers/main"

const UseCart = ({ cart }) => {
    const dispatch = useDispatch()
    const total = calculateTotalCart(cart)
    useEffect(() => {
        dispatch(updateCart(cart))
    }, [ total ])
    return <></>
}

export default UseCart